import {BTCWalletAdapter} from "../WalletAdapter";
import {
    AddressPurpose,
    BitcoinNetworkType, Capability,
    getCapabilities,
    signMessage,
    request,
} from "sats-connect";
import matchlog from "../../utils/matchlog";

export class XverseAdapter implements BTCWalletAdapter {
    name = "Xverse Wallet";
    website = "https://www.xverse.app/"
    capabilities: Set<Capability> | null = null;
    address = '';
    network = BitcoinNetworkType.Mainnet;
    walletKey = "xverse"

    async isInstalled() {
        return new Promise<boolean>(async (resolve) => {
            try {
                await getCapabilities({
                    onFinish: (response: any) => {
                        matchlog.log(response)
                        this.capabilities = (new Set(response));
                        resolve(true);
                    },
                    onCancel() {
                    },
                    payload: {
                        network: {
                            type: this.network
                        },
                    },
                });
            } catch (err) {
                matchlog.error(err)
                resolve(false);
            }


        });
    }

    async connect(): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Xverse Wallet is not installed");
        const response = await request('getAccounts', {
            purposes: [AddressPurpose.Ordinals],
            message: 'SATS Connect Demo',
        });
        matchlog.log("getAccounts ~ response:", response)
        if (response.status === 'success') {
            const ordinalsAddressItem = response.result.find(
                (address) => address.purpose === AddressPurpose.Ordinals
            );
            this.address = ordinalsAddressItem?.address || '';
            return ordinalsAddressItem?.address || '';

        } else {
            if (response.error) {
                console.error(response.error)
                throw new Error("Error getting accounts. Check console for error logs");
            }
            throw new Error("Error getting accounts");
        }
    }

    async signMessage(message: string): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Xverse Wallet is not installed");
        return new Promise<string>(async (resolve, reject) => {
            await signMessage({
                payload: {
                    network: {
                        type: this.network,
                    },
                    address: this.address,
                    message,
                },
                onFinish: (response) => {
                    resolve(response);
                },
                onCancel: () => {
                    reject("User cancelled")
                }
            });

        });
    }

    async disconnet(): Promise<void> {
        if (!await this.isInstalled()) throw new Error("Xverse Wallet is not installed");
        await request('wallet_disconnect', null);
    }
}
